export default __webpack_public_path__ + "static/media/Logo_Premier.af570124.png";